import FilesSidebar from './container'
export { FilesSidebar }
export default FilesSidebar